// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  padding-bottom: 20px;
}
.black-color {
  color: #1A1A18;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  background: transparent;
  height: 60px;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}

.title {
  cursor: pointer;
  position: relative;
  margin: 0;
  font-family: AppFontBold, sans-serif;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  text-transform: capitalize;
  color: #1A1A18;
}

.name {
  font-family: AppFontBold, sans-serif;
  font-size: 12px;
  line-height: 15px;
  color: #1A1A18;
  text-align: left;
  padding: 15px 0px;
}

p {
  padding: 15px 0px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 11.5px;
  line-height: 20px;
  color: #1A1A18 !important;
}

div {
  position: relative;
  transition: max-height linear 0.3s;
}
div ion-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.active {
  max-height: -moz-fit-content;
  max-height: fit-content;
  overflow: hidden;
}

.inactive {
  max-height: 0;
  overflow: hidden;
}

.nutrition-name {
  font-size: 10px;
  text-align: left;
  color: #1A1A18;
  padding-left: 20px;
}

.nutrition-value {
  text-align: right;
  color: #1A1A18;
  font-size: 10px;
  padding-right: 20px;
}

.border-top {
  border-top: 1px solid #dcdddc;
}

.allergens_title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--ion-color-black);
}

ul {
  margin: 0px;
  padding: 0px 30px;
}
ul li {
  font-size: 10px;
  text-align: left;
  color: #1A1A18 !important;
  padding: 6px 0px;
}

.padding-top {
  padding-top: 15px;
}

.final_text {
  padding: 10px 0px;
}

.separator {
  height: 14px;
  width: 100%;
  background: url('separator_doted.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator {
    background: url('separator_doted.svg') no-repeat center center/100% 130%;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/accordion-list/accordion-list.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACG,WAAA;EAKA,oBAAA;AALH;AAOA;EACG,cAAA;AALH;;AAQA;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AALH;AAOM;EACG,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AALT;AAMS;EACG,YAAA;AAJZ;;AAUA;EACG,eAAA;EACA,kBAAA;EACA,SAAA;EAGA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AATH;;AAYA;EACG,oCAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;EACA,gBAAA;EACA,iBAAA;AAVH;;AAaA;EACG,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,iBAAA;EAEA,yBAAA;AAXH;;AAcA;EACG,kBAAA;EACA,kCAAA;AAXH;AAaG;EACG,kBAAA;EACA,YAAA;EACA,WAAA;AAXN;;AAeA;EACG,4BAAA;EAAA,uBAAA;EACA,gBAAA;AAZH;;AAeA;EACG,aAAA;EACA,gBAAA;AAZH;;AAcA;EACG,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAXH;;AAaA;EACG,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAVH;;AAYA;EACG,6BAAA;AATH;;AAWA;EACG,gCAAA;EACA,eAAA;EACA,6BAAA;AARH;;AAUA;EACG,WAAA;EAEA,iBAAA;AARH;AASG;EACG,eAAA;EACA,gBAAA;EACA,yBAAA;EAEA,gBAAA;AARN;;AAWA;EACG,iBAAA;AARH;;AAWA;EACG,iBAAA;AARH;;AAeA;EACC,YAAA;EACA,WAAA;EACA,wEAAA;AAZD;AC3HE;EDoIF;IAKI,wEAAA;EAVF;AACF;AAUE;EANF;IAOG,YAAA;EAPD;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.container {\n   width: 100%;\n   // background: #EAEAEB;\n   &.activated {\n      // background: white;\n   }\n   padding-bottom: 20px;\n}\n.black-color {\n   color: #1A1A18;\n\n}\n.header {\n   display: flex;\n   align-items: center;\n   justify-content: space-between;\n   padding: 10px 0px;\n   background: transparent;\n   height: 60px;\n   .icon_wrapper {\n      ion-icon {\n         height: 10px;\n         width: 10px;\n         rotate: 180deg;\n         transition: rotate 0.5s;\n         margin-left: 10px;\n         &.isOpen{\n            rotate: 0deg;\n         }\n      }\n   }\n}\n\n.title {\n   cursor: pointer;\n   position: relative;\n   margin: 0;\n\n\n   font-family: AppFontBold, sans-serif;\n   font-size: 13px;\n   line-height: 16px;\n   text-align: left;\n   text-transform: capitalize;\n   color: #1A1A18;\n}\n\n.name {\n   font-family: AppFontBold, sans-serif;\n   font-size: 12px;\n   line-height: 15px;\n\n   color: #1A1A18;\n   text-align: left;\n   padding: 15px 0px;\n}\n\np {\n   padding: 15px 0px;\n   text-align: left;\n   font-family: AppFont, sans-serif;\n   font-size: 11.5px;\n   line-height: 20px;\n\n   color: #1A1A18 !important;\n}\n\ndiv {\n   position: relative;\n   transition: max-height linear 0.3s;\n\n   ion-button {\n      position: absolute;\n      bottom: 20px;\n      right: 20px;\n   }\n}\n\n.active {\n   max-height: fit-content;\n   overflow: hidden;\n}\n\n.inactive {\n   max-height: 0;\n   overflow: hidden;\n}\n.nutrition-name {\n   font-size: 10px;\n   text-align: left;\n   color: #1A1A18;\n   padding-left: 20px;\n}\n.nutrition-value {\n   text-align: right;\n   color: #1A1A18;\n   font-size: 10px;\n   padding-right: 20px;\n}\n.border-top {\n   border-top: 1px solid #dcdddc;\n}\n.allergens_title {\n   font-family: AppFont, sans-serif;\n   font-size: 16px;\n   color: var(--ion-color-black);\n}\nul {\n   margin: 0px;\n   // list-style-type: none;\n   padding: 0px 30px;\n   li {\n      font-size: 10px;\n      text-align: left;\n      color: #1A1A18 !important;\n\n      padding: 6px 0px;\n   }\n}\n.padding-top {\n   padding-top: 15px;\n}\n\n.final_text {\n   padding: 10px 0px;\n   // p {\n   //    text-align: left;\n   //    font-size: 12px;\n   //    font-weight: bold;\n   // }\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n    background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
